import { Button, Flex, Text } from '@chakra-ui/react';
// @ts-ignore
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @ts-ignore
import styles from '../../assets/css/modular/admin.module.css';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../components/form-components/FormikControl';
import axios from 'axios';
import ToastMessage from '../../components/utility/ToastMessage';
import CustomSpinner from '../../components/utility/CustomSpinner';

const token = localStorage.getItem('my_token');

export default function EditDesignation(){
    const [isLoading, setIsLoading] = useState(false);
    const [ designationInfo, setDesignationInfo ] = useState({});
    const { id } = useParams();

    const config = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
    };

    useEffect(() => {
        fetchDesignation(id);
    }, [id]);

    const fetchDesignation = async (id) => {
        setIsLoading(true);

        try {
            var apiResponse = (
                await axios.get(`${process.env.REACT_APP_API_URL}/api/designation/${id}`, {
                    headers: config
                })
            ).data;

            const results = apiResponse.results;

            if (results?.designation) {
                setDesignationInfo(results);
            }else{
                setDesignationInfo({});
            }
        } catch (err) {
            ToastMessage('error','Something went wrong');
        }

        setIsLoading(false);
    }

    const DisplayData = () => {
        return (
            <>
                { isLoading
                    ? <CustomSpinner />
                    : designationInfo?.id
                        ? <EditDesignationForm designationInfo={designationInfo} id={id} />
                        : <p>Nothing Found with this</p>
                }
            </>
        )
    }

    return <DisplayData />;
}

const EditDesignationForm = ({designationInfo, id}) =>{
    // @ts-ignore
    const navigate = useNavigate();
    const token = localStorage.getItem('my_token');

    const [errors, setErrors] = useState({
        designation: []
    });

    const fetchData = () => {
        let init = {
            designation: designationInfo?.designation,
            type: designationInfo?.type,
        };

        return init;
    }

    const validationSchema = Yup.object({
        designation: Yup.string().required('Required'),
        type: Yup.string().required('Required'),
    });

    const onSubmit = (values) => {
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`
              }
        };

        axios
            .patch(`${process.env.REACT_APP_API_URL}/api/designation/${id}`, values, config)
            .then((response) => {
                ToastMessage('success','Successfully updated');
                navigate('/designations');
            })
            .catch((error) => {
                const {data, status} = error?.response;

                let message = 'Something went wrong';
                if(status == 422) {
                    message = 'Invalid Input';
                }

                const { errors } = data;

                setErrors({
                    ...errors,
                    designation: errors?.designation
                });

                ToastMessage('error',message);
            });
    };

    const typeOptions = () => {
        let rtn = [
            {key: '', value: "Select an option"},
            {key: 3, value: "Teacher"},
            {key: 6, value: "Officer"},
            {key: 7, value: "Staff"},
        ];

        return rtn;
    }

    return (
        <>
            <Flex justifyContent={'center'} className="admin_title">
                <Text fontSize="xl">EDIT DESIGNATION</Text>
            </Flex>

            <div className={styles.apply_form}>
                <Formik
                    initialValues={fetchData()}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {
                        formik => (
                            <Form>
                                <FormikControl required={true} control='input' type='text' label='Designation' name='designation' placeholder="Enter Designation" />
                                <FormikControl required={true} control='select' label='Designation For (Type)' name='type' options={typeOptions()} />

                                <div>
                                    <Button colorScheme="green" type="submit">Submit</Button>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </>
    )
}
